import { ApolloClient, InMemoryCache, split, HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getMainDefinition } from '@apollo/client/utilities';
import { onError } from '@apollo/client/link/error';
import { RetryLink } from '@apollo/client/link/retry';

import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';

// 创建 HTTP link
const httpLink = new HttpLink({
  uri: process.env.REACT_APP_BIDGRAPHQL_SERVER_URI,
  fetchOptions: {
    timeout: 10000, // 10 seconds timeout
  },
});

// 创建 WebSocket link
const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.REACT_APP_BIDGRAPHQL_WS_URI,
    retryAttempts: 5,
    keepAlive: 30000,
    onPing: () => {
      console.log('Received ping, sending pong');
    },
    onError: (error) => {
      console.log('WebSocket Error:', error);
      console.log('WebSocket Connection Error. Please refresh the page.');
      window.location.reload();
    },
  })
);

// CSRF token 设置
const csrfToken = window.csrfToken || '';

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    'X-CSRFToken': csrfToken,
  },
}));

// 错误处理 link
const errorLink = onError(({ networkError }) => {
  if (networkError) {
    console.log('Network Error:', networkError); // 调试错误信息
    if (networkError.statusCode === 502) {
      console.log('Bad Gateway Error: 502'); // 输出 502 错误
      console.log('Network Error: 502 Bad Gateway. Please refresh the page.');
    }
  }
});

// 重试 link，设置重试逻辑
const retryLink = new RetryLink({
  delay: {
    initial: 300,  // 初始延迟300毫秒
    max: 5000,     // 最大延迟5秒
    jitter: true,  // 随机抖动
  },
  attempts: {
    max: 2,  // 最大重试次数
    retryIf: (error, _operation) => {
      const shouldRetry = !!error && error.statusCode === 502;
      if (shouldRetry) {
        console.log('Retrying...');  // 输出重试信息
      }
      return shouldRetry;  // 当出现502错误时重试
    },
  },
});


// 确定请求类型并分发到 HTTP 或 WebSocket link
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink
);

// 合并 links
const link = errorLink.concat(retryLink).concat(authLink).concat(splitLink);

const client = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
});

export default client;
